export var NumericOperators;
(function (NumericOperators) {
    NumericOperators["GREATER_THAN_OPERATOR"] = "GREATER_THAN";
    NumericOperators["GREATER_THAN_OR_EQUALS_OPERATOR"] = "GREATER_THAN_OR_EQUALS";
    NumericOperators["LESS_THAN_OPERATOR"] = "LESS_THAN";
    NumericOperators["LESS_THAN_OR_EQUALS_OPERATOR"] = "LESS_THAN_OR_EQUALS";
    NumericOperators["EQUALS_OPERATOR"] = "EQUALS";
    NumericOperators["NOT_EQUALS_OPERATOR"] = "NOT_EQUALS";
    NumericOperators["NUMERIC_OPERATOR_UNSPECIFIED"] = "UNSPECIFIED";
})(NumericOperators || (NumericOperators = {}));
